var loaders = require('../../layout/components/loaders');

const serviceModel = {};

serviceModel.serviceClassTree = {categories: [], service: {}, measurable: {}};
serviceModel.measurableClassTree = serviceModel.serviceClassTree;

serviceModel.requestClassTree = function () {
  serviceModel.serviceClassTree = {categories: [], service: {}, measurable: {}};
  serviceModel.measurableClassTree = serviceModel.serviceClassTree;
  return loaders.requestWithLoader({
    loader: 'main',
    url: '/api/v1/serviceclasstree',
    method: 'GET'
  })
  .then(res => {
    serviceModel.serviceClassTree = res;
    serviceModel.serviceClassTree.service = serviceModel.serviceClassTree.service || serviceModel.serviceClassTree.measurable || {};
    serviceModel.serviceClassTree.measurable = serviceModel.serviceClassTree.service;
    serviceModel.measurableClassTree = serviceModel.serviceClassTree;
    serviceModel.serviceClassTree.categories.forEach((c, i) => columnsByMainServiceCategory(c, i));
    return serviceModel.serviceClassTree;
  });
};

serviceModel.getClassTree = function () {
  if (!serviceModel.serviceClassTree.categories.length) {
    return serviceModel.requestClassTree();
  } else {
    return Promise.resolve(serviceModel.serviceClassTree);
  }
};

serviceModel.saveChildrenClassData = function (data) {
  return loaders.requestWithLoader({
    loader: 'main',
    url: '/api/v1/serviceclassdata',
    method: 'POST',
    body: data
  })
  .then(() => serviceModel.requestClassTree());
};

serviceModel.renameClass = function (originalName, newName) {
  return loaders.requestWithLoader({
    loader: 'main',
    url: `/api/v1/serviceclass/${encodeURIComponent(originalName)}`,
    method: 'PUT',
    body: { name: newName }
  })
  .then(() => serviceModel.requestClassTree());
};

serviceModel.deleteClass = function (className) {
  return loaders.requestWithLoader({
    loader: 'main',
    url: `/api/v1/serviceclass/${encodeURIComponent(className)}`,
    method: 'DELETE'
  })
  .then(() => serviceModel.requestClassTree());
};

function columnsByMainServiceCategory (mainServiceCategory, idx){
  serviceModel.serviceClassTree.categories[idx].allChildrenColumns = [];
  let mainServiceCategoryData = serviceModel.serviceClassTree.categories[idx];
  addCategoryColumns(mainServiceCategoryData, idx);
}

function addCategoryColumns (category, idx){
  if(category.data && category.data.columns && Array.isArray(category.data.columns)) {
    category.data.columns.forEach(columnRecord=> {
      if(!serviceModel.serviceClassTree.categories[idx].allChildrenColumns.find(c=> c.name == columnRecord.name)){
        serviceModel.serviceClassTree.categories[idx].allChildrenColumns.push(columnRecord);
      }
    });
  }
  if(Array.isArray(category.children) && category.children.length > 0) {
    category.children.forEach(childrenCategory =>{
      addCategoryColumns(childrenCategory, idx);
    });
  }
}

module.exports = serviceModel;
